import { h } from "preact";
import { useState, useContext } from "preact/hooks";

import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreCollectionDataWithLimit,
  getOnLineStatus,
  useUser,
} from "../lib/preactfire";
import { Context } from "../lib/globalState";

import Header from "./Header";
import Footer from "./Footer";
import CommentsTab from "./CommentsTabs";
import CommentsTabContent from "./CommentsTabsContent";
import CommentItem from "./CommentItem";
import LoadingContentPreloader from "./LoadingContentPreloader";
import { removeOverlay } from "../lib/helper";

export default function AllComments({ visible, setVisible }) {
  const {
    state: { apiKey, storyUrl },
  } = useContext(Context);

  const status = getOnLineStatus();

  const [limit, setLimit] = useState(5);

  if (visible) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const user = useUser();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const commentsRef = useFirestore()
      .collection("comment")
      .where("api_key", "==", apiKey)
      .where("type", "==", "comment")
      .where("page", "==", storyUrl)
      .orderBy("timestamp", "desc");
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const commentsCount = useFirestoreCollectionData(commentsRef).length;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const comments = useFirestoreCollectionDataWithLimit(commentsRef, limit);

    return (
      <div>
        {status && (
          <Header
            visible={visible}
            onClick={setVisible}
            loader={commentsCount || comments !== undefined}
            online={status}
          />
        )}

        {/* If Offline */}
        {visible && !status && (
          <div className="comment-container">
            <CommentsTab count={commentsCount} />
            <div className="comments-content-wrapper" id="container">
              <CommentsTabContent />
            </div>
            <div className="comments-content-wrapper">
              <div className="comment-wrapper center">
                You're offline. Comments will load once you're online.
              </div>
            </div>
            <Footer />
          </div>
        )}

        {visible && comments?.length === 0 && status && (
          <div className="comment-container">
            <CommentsTab count={commentsCount} />
            <div className="comments-content-wrapper" id="container">
              <CommentsTabContent />
            </div>
            <div className="comments-content-wrapper">
              <div className="comment-wrapper center">
                No comment found for the selected story
              </div>
            </div>
            <Footer />
          </div>
        )}

        {visible && comments?.length > 0 && status && (
          <div className="comment-container">
            <CommentsTab count={commentsCount} />
            <div className="comments-content-wrapper" id="container">
              <CommentsTabContent />
            </div>
            <div className="comments-content-wrapper">
              <div className="comment-item-container">
                {comments?.length === 0 ? (
                  <LoadingContentPreloader />
                ) : (
                  comments
                    ?.filter(
                      (comment) =>
                        !comment?.flags?.some(
                          (flag) => flag?.user_id === user?.uid
                        )
                    )
                    .map((comment, index) => (
                      <CommentItem key={index} comment={comment} />
                    ))
                )}

                {commentsCount !== comments.length && (
                  <div className="loading-content">
                    <button
                      type="button"
                      name="button"
                      className="load-feed"
                      id="load_more"
                      onClick={() => setLimit((_limit) => _limit + 5)}
                    >
                      Load More
                    </button>
                  </div>
                )}
              </div>
            </div>
            <Footer />
          </div>
        )}
        <div
          id="mobile-overlay"
          class="mobile-overlay"
          onClick={() => removeOverlay()}
        />
      </div>
    );
  }

  return (
    <div>
      <Header visible={visible} onClick={setVisible} />
    </div>
  );
}
